export default "__VITE_ASSET__ge9UNXy6__"